<template>
	<div class="header">
		<div class="container-fluid">
			<!-- Hearer  -->
			<div class="mt-4">
				<div class="card">
					<div class="card-body">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item fw-bolder">Master Data</li>
								<li class="breadcrumb-item">Organization</li>
							</ol>
						</nav>
					</div>
				</div>
			</div>
			<!-- Card  -->
			<div class="card mt-5">
				<div class="card-header">
					<!-- Title -->
					<h4 class="card-header-title">Organization</h4>
					<!-- Button -->
					<b-button v-b-modal.modal-1 variant="primary" @click="isAdd = true" v-if="canAdd">
						<span class="fe fe-plus-circle"></span>
						Add Organization
					</b-button>
				</div>
				<div class="d-flex justify-content-end mb-3 mt-3 mr-3">
					<label class="align-self-center mb-0 mr-3">Search</label>
					<b-form-input v-model="body.search" class="w-auto" placeholder="Type Here..." @input="filterData()">
					</b-form-input>
				</div>
				<div class="text-center" v-show="isLoading == true">
					<div class="spinner-border" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>
				<div class="overflow-auto" v-show="isLoading == false">
					<vue-good-table
						:line-numbers="true"
						:columns="columns"
						:rows="list.data"
						:sort-options="{
							enabled: true,
						}"
						:total-rows="list.totalItems"
						:pagination-options="{
							enabled: true,
							mode: 'pages',
							position: 'bottom',
							perPage: this.body.limit || 10,
							perPageDropdown: [10, 50, 100],
							dropdownAllowAll: false,
							setCurrentPage: this.body.page,
							nextLabel: 'next',
							prevLabel: 'prev',
							rowsPerPageLabel: 'Rows per page',
							ofLabel: 'of',
							pageLabel: 'page',
							allLabel: 'All',
						}"
						style-class="vgt-table border-0 table"
						@on-page-change="onPageChange"
						@on-per-page-change="onPageChange"
						@on-sort-change="onSortChange"
					>
						<!-- Loading -->
						<div slot="emptystate" class="text-center font-size-14">No data available</div>
						<!-- Custom Rows -->
						<template slot="table-row" slot-scope="props">
							<!-- Table Action -->
							<span v-if="props.column.field == 'action'">
								<b-button class="no-wrap btn-pill" variant="warning" size="sm" @click="updateData(props.row)" v-if="canEdit">
									<span class="fe fe-edit"></span>
								</b-button>
								<b-button
									class="no-wrap ml-2"
									variant="danger"
									style="margin-left: 5px"
									size="sm"
									@click="deleteData(props.row.id)"
									v-if="canDelete"
								>
									<span class="fe fe-trash-2"></span>
								</b-button>
							</span>
						</template>
					</vue-good-table>
				</div>
			</div>

			<!-- Modal -->
			<b-modal
				id="modal-1"
				hide-footer
				:title="`${isAdd ? 'Add' : 'Update'} Organization`"
				@hide="closeNotification($event)"
			>
				<form @submit.prevent="save()">
					<div class="form-group">
						<label>Name <span class="text-danger">*</span></label>
						<input
							type="text"
							class="form-control"
							placeholder="Department/Division name"
							v-model="organization.name"
							v-validate="'required'"
							name="Name"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
					</div>
					<div class="form-group">
						<label>Department Code <span class="text-danger">*</span></label>
						<input
							type="text"
							class="form-control"
							placeholder="Department Code"
							v-model="organization.code"
							v-validate="'required'"
							name="Code"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Code')">{{ errors.first('Code') }}</span>
					</div>
					<div class="form-group float-end">
						<button class="mt-4 btn btn-outline-light mr-2" type="button" @click="confirmAndCloseModal()">Cancel</button>
						<button class="mt-4 btn btn-primary" type="submit" v-if="isLoading == false">Save</button>
						<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</form>
			</b-modal>
		</div>
	</div>
</template>

<script>
	import { authorize } from '@/utils/authorize';
	import { debounce } from 'lodash';
	export default {
		name: 'listContract',
		computed: {
			list() {
				let dataList = this.$store.getters['organization/list'];
				if (dataList && dataList.data) {
					dataList.data = dataList.data.map((item) => {
						return {
							id: item.id,
							department_name: item.name,
							division_name: item.parent?.name,
							parent_id: item.parent_id,
							code: item.code,
						};
					});
					return dataList;
				}
				return [];
			},
		},
		data() {
			return {
				body: {
					page: 1,
					limit: 10,
					search: '',
					order: '',
				},
				isAdd: true,
				isLoading: false,
				columns: [
					{
						label: 'Name',
						field: 'department_name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Department Code',
						field: 'code',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				organization: {
					id: null,
					parent_id: null,
					name: '',
					code: '',
					isDepartment: false,
				},
				canAdd: false,
				canEdit: false,
				canDelete: false,
			};
		},
		async mounted() {
			await this.getList();
			this.canAdd = await authorize('/organization', 'create');
			this.canEdit = await authorize('/organization', 'update');
			this.canDelete = await authorize('/organization', 'delete');
			this.debounceSearch = debounce(this.getList, 500);
		},
		methods: {
			//action
			updateData(props) {
				this.$bvModal.show('modal-1');
				this.isAdd = false;
				this.organization = {
					id: props.id,
					parent_id: props.parent_id,
					name: props.department_name,
					isDepartment: props.parent_id ? true : false,
					code: props.code,
				};
			},

			reset() {
				this.organization = {
					id: null,
					parent_id: null,
					name: '',
					isDepartment: false,
					code: '',
				};
				this.isAdd = true;
			},

			closeNotification(evt) {
				if (evt.trigger === 'backdrop') {
					evt.preventDefault();
				}
				if (evt.trigger === 'headerclose') {
					evt.preventDefault();
					this.confirmAndCloseModal();
				}
			},

			confirmAndCloseModal() {
				this.$swal({
					title: 'Confirm Close?',
					text: 'Are you sure you want to close this page?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$bvModal.hide('modal-1');
						this.reset();
					} else {
						console.log('Modal close cancelled from button.');
					}
				});
			},

			getList() {
				this.isLoading = true;
				this.$store
					.dispatch('organization/GET_LIST', this.body)
					.then(() => {
						this.isLoading = false;
					})
					.catch(() => {
						this.isLoading = false;
						this.$swal('Error', 'Error while get data', 'error');
					});
			},

			async save() {
				this.$validator.validateAll().then(async (res) => {
					if (!res) return false;
					try {
						this.isLoading = true;
						if (this.isAdd) {
							await this.$store.dispatch('organization/CREATE_DATA', this.organization).then(() => {
								this.$swal('Saved', 'Your input has been saved', 'success').then(async () => {
									await this.getList();
								});
							});
						} else {
							await this.$store.dispatch('organization/UPDATE_DATA', this.organization).then(() => {
								this.$swal('Saved', 'Your input has been updated', 'success').then(async () => {
									await this.getList();
								});
							});
						}
						this.isLoading = false;
						this.isAdd = true;
						this.$bvModal.hide('modal-1');
						this.reset();
					} catch (error) {
						console.error(error);
						this.$swal('Error', error?.response?.data?.error || 'Error while add data', 'error');
						this.isLoading = false;
					}
				});
			},

			deleteData(id) {
				this.$swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes, delete it!',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$store
							.dispatch('organization/DELETE_DATA', id)
							.then(async () => {
								await this.getList();
								this.$swal('Deleted!', 'Your data has been deleted', 'success');
							})
							.catch(() => {
								this.$swal('Error', 'Error while delete data', 'error');
							});
					}
				});
			},
			// Pagination
			onPageChange(payload) {
				this.body.limit = payload.currentPerPage;
				this.body.page = payload.currentPage;
				this.getList();
			},
			onSortChange(payload) {
				const sort = [];
				if (payload[0].field == 'department_name') {
					sort.push(['name', payload[0].type == 'desc' ? 'desc' : 'asc']);
				} else {
					sort.push([payload[0].field, payload[0].type == 'desc' ? 'desc' : 'asc']);
				}
				this.body.order = sort.join(',');
				this.body.page = 1;
				this.getList();
			},
			filterData() {
				this.body.page = 1;
				this.debounceSearch();
			},
		},
	};
</script>
